import {Inject, Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {take} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {

  constructor(@Inject(TranslateService) private translate: TranslateService, @Inject(HttpClient) private http: HttpClient) {
  }

  setTranslations(language: string = 'en', flavor: string = 'default') {
    if (flavor !== 'default') {
      this.setDefault(language);
    }

    this.http.get<any>(`/i18n/${flavor}/${language}.json`).pipe(take(1)).subscribe({
      next: (translations) => {
        this.translate.setTranslation(language, translations || {}, true);
        this.translate.use(language);
      },
      error: () => {
        this.translate.use(language);
      }
    });

  }

  private setDefault(language: string = 'en') {
    this.translate.setDefaultLang('default');

    this.http.get<any>(`/i18n/default/en.json`).pipe(take(1)).subscribe((translations) => {
      this.translate.setTranslation('default', translations || {});
      this.translate.setTranslation(language, translations || {}, true);

      if (language !== 'en') {
        this.http.get<any>(`/i18n/default/${language}.json`).pipe(take(1)).subscribe((translations) => {
          this.translate.setTranslation('default', translations || {}, true);
          this.translate.setTranslation(language, translations || {}, true);
        });
      }
    });

  }

}
